module.exports = __webpack_public_path__ + "img/53.8.TSS.efd8294d.png";